import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import type { ListingList } from "../post/types";

const norm = (t?: string): string => (t ?? "").toLowerCase().replace(/\s/g, "");
const rank = (t?: string): number => (norm(t) === "mybrand" ? 1 : norm(t) === "leadgeneration" ? 2 : 0);

/** Today's dropdown order: property campaigns first, My Brand, then Lead Generation. No Text Only clone: the My Brand card covers it. */
export function sortListingRows(rows: ListingList[]): ListingList[] {
    return [...rows].sort((a, b) => rank(a.listingType) - rank(b.listingType));
}

export interface UseListingListReturn {
    rows: ListingList[];
    loading: boolean;
    error: boolean;
    refresh: () => Promise<void>;
}

export function useListingList(): UseListingListReturn {
    const [rows, setRows] = useState<ListingList[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const refresh = useCallback(async () => {
        try {
            const headers = await getAuthHeader();
            const res = await axios.get<ListingList[]>(`${process.env.REACT_APP_BACKEND_URL}/post/listing-list`, { headers });
            setRows(sortListingRows(Array.isArray(res.data) ? res.data : []));
            setError(false);
        } catch {
            setError(true);
        } finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => { void refresh(); }, [refresh]);
    return { rows, loading, error, refresh };
}
